import React, { useEffect, useState } from 'react';
import { Alert, Badge, Button, Card, Container, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import NavbarStandard from 'components/pages/landing/NavbarStandard';
import FooterStandard from 'components/pages/landing/FooterStandard';
import { fetchPublicBlogPostBySlug } from 'helpers/blog';

const PublicBlogDetailPage = () => {
  const { t } = useTranslation();
  const { slug } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [post, setPost] = useState(null);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError('');
      try {
        const response = await fetchPublicBlogPostBySlug(slug);
        setPost(response.post || null);
      } catch (requestError) {
        setPost(null);
        setError(requestError.response?.data?.error || t('BLOG.ERROR_LOAD'));
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [slug, t]);

  return (
    <>
      <NavbarStandard solid />
      <main>
        <section className="py-6 mt-6 bg-300">
          <Container>
            <Button as={Link} to="/blog" variant="link" className="ps-0 mb-2">
              {t('BLOG.BACK_TO_PUBLIC_LIST')}
            </Button>
            {loading ? (
              <div className="text-center py-6">
                <Spinner animation="border" />
              </div>
            ) : null}

            {!loading && error ? <Alert variant="danger">{error}</Alert> : null}

            {!loading && !error && post ? (
              <>
                <div className="d-flex gap-2 flex-wrap mb-3">
                  {post.category ? <Badge bg="light" text="dark">{post.category}</Badge> : null}
                  {post.is_featured ? <Badge bg="warning" text="dark">{t('BLOG.STATUS_FEATURED')}</Badge> : null}
                </div>
                <h1 className="mb-2">{post.title}</h1>
                {post.subtitle ? <p className="text-700 fs-1 mb-3">{post.subtitle}</p> : null}
                <div className="text-500 fs--1">
                  {[post.author_name || post.author?.full_name || 'Gestodo', post.reading_time].filter(Boolean).join(' · ')}
                </div>
              </>
            ) : null}
          </Container>
        </section>

        {!loading && !error && post ? (
          <section className="py-5">
            <Container>
              <Card className="border">
                {post.cover_image_url ? (
                  <div className="ratio ratio-4x3">
                    <img
                      src={post.cover_image_url}
                      alt={post.title}
                      style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                    />
                  </div>
                ) : null}
                <Card.Body className="p-4 p-lg-5">
                  <div
                    className="blog-content"
                    dangerouslySetInnerHTML={{ __html: post.content || '' }}
                  />
                </Card.Body>
              </Card>
            </Container>
          </section>
        ) : null}
      </main>
      <FooterStandard />
    </>
  );
};

export default PublicBlogDetailPage;
